/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AppointmentDetailsPopup from "./Popup/AppointmentDetailsPopup";
import AppointmentListFilterPopup from "./Popup/AppointmentListFilterPopup";
import SaveAppointmentPopup from "components/Common/Popup/SaveAppointmentPopup";

const AppointmentsSection = ({ patientObj = null }) => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]); // Renamed

  const [rowSelection, setRowSelection] = useState({});
  const [selectedAppointmentIds, setSelectedAppointmentIds] = useState([]); // Renamed
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null); // Renamed
  const [selectedTagId, setSelectedTagId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  // get all appointments
  const getAllAppointmentsByPatientId = async () => {
    // Renamed
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_AGENDA +
        `?token=${token}&associateduser=${params.id}&issent=true`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in appointment list------->", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setAppointmentList(response.data); // Renamed
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //function for remove tag from appointment
  const removeTagFromAppointment = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_AGENDA;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedAppointmentId(null);
      }, 1000);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setAppointmentList((prevList) => mergeListById(prevList, data)); // Renamed
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllAppointmentsByPatientId();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllAppointmentsByPatientId();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#appointmentDetailsPopup"
            aria-controls="appointmentDetailsPopup"
            onClick={() => {
              setSelectedAppointmentId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Appointment Date",
        accessorKey: "date",
        size: 150,
        Cell: ({ row }) => (
          <span>{getDateFormatInSpanish(row.original.date)}</span>
        ),
      },
      {
        header: "Start Time",
        accessorKey: "starttime",
      },
      {
        header: "End Time",
        accessorKey: "endtime",
      },
      //doctor
      {
        header: "Doctor",
        accessorKey: "receivername",
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.receiverimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.receiverimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.receivername}</span>
            </p>
          </div>
        ),
      },
      //company
      {
        header: "Clinic",
        accessorKey: "companyname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.companyname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.companylogo == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.companylogo
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.companyname}</span>
            </p>
          </div>
        ),
      },
      //location
      {
        header: "Location",
        accessorKey: "location",
      },
      //duration
      {
        header: "Duration",
        accessorKey: "duration",
        Cell: ({ row }) => <span>{row.original.duration} hours</span>,
      },
    ],
    [selectedAppointmentId, selectedTagId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedAppointmentIds(selectedIdsArray); // Renamed
    } else {
      setSelectedAppointmentIds([]); // Renamed
    }
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <h3 className="mb-3">Appointments</h3>
          </div>

          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>

            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#appointmentListFilter"
              aria-controls="appointmentListFilter"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveAppointmentOffCanvas"
              aria-controls="saveAppointmentOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={appointmentList}
            enableGrouping
            enableRowSelection={false}
            getRowId={(row) => row._id}
            state={{ columnOrder }}
            initialState={{ columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* popup and modals */}
      <SaveAppointmentPopup // Renamed
        selectedAppointmentId={selectedAppointmentId} // Renamed
        setSelectedAppointmentId={setSelectedAppointmentId} // Renamed
        afterActionClose={afterActionClose}
        patientObj={patientObj}
        // setShowAlert={setShowAlert}
        // setAlertMessage={setAlertMessage}
        // setMessageType={setMessageType}
      />

      <AppointmentDetailsPopup
        selectedAppointmentId={selectedAppointmentId}
        setSelectedAppointmentId={setSelectedAppointmentId}
      />

      <AppointmentListFilterPopup
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={getAllAppointmentsByPatientId}
        moduleSlug="patientappointment"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columnOrder={columnOrder}
        columns={columns}
      />
    </div>
  );
};

export default AppointmentsSection;
